import indexMixin from "../mixins/index";
export default {
  name: "res-rate",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value // show-score（和show-text 不能同时为真）

    };
  },

  props: {
    value: {
      type: Number,
      default: 0
    },
    showText: {
      type: Boolean,
      default: false
    },
    texts: {
      type: [Object, Array],
      default: () => ["极差", "失望", "一般", "满意", "惊喜"]
    },
    scoreTemplate: {
      type: String,
      default: "{value}"
    }
  },
  computed: {
    valueToLabel() {
      if (this.showText) {
        // 展示文字
        return this.texts[Math.ceil(this.dataModel) - 1];
      } // 展示分数


      return this.scoreTemplate.replace(/\{value\}/, this.dataModel);
    }

  },
  watch: {
    dataModel(val) {
      this.$emit("input", val);
    },

    value(value) {
      this.dataModel = value;
    }

  }
};